var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImageWrapper',{attrs:{"src":_vm.src,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }